import styled from 'styled-components';

export const BtnContainer = styled.div`
  margin-top: 2rem;
`;
